import { useState, useEffect } from "react";
import { useLocation } from "wouter";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowUpCircle } from "lucide-react";

export function PlanLimitDialog() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [, setLocation] = useLocation();

  useEffect(() => {
    function handlePlanLimitExceeded(e: Event) {
      const detail = (e as CustomEvent<{ message: string }>).detail;
      setMessage(detail?.message || "You have reached your plan limit.");
      setOpen(true);
    }

    window.addEventListener("plan-limit-exceeded", handlePlanLimitExceeded);
    return () => window.removeEventListener("plan-limit-exceeded", handlePlanLimitExceeded);
  }, []);

  function handleUpgrade() {
    setOpen(false);
    setLocation("/pricing");
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
              <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <DialogTitle className="text-lg">Plan Limit Reached</DialogTitle>
          </div>
          <DialogDescription className="text-sm text-muted-foreground leading-relaxed pt-1">
            {message}
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 p-4 text-sm text-amber-800 dark:text-amber-300">
          Upgrade your plan to unlock higher limits and access all features.
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Dismiss
          </Button>
          <Button onClick={handleUpgrade} className="gap-2">
            <ArrowUpCircle className="h-4 w-4" />
            View Plans &amp; Upgrade
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
